namespace TabAurous.OMS {
    export interface DesignBOMRow {
        BomId?: number;
        DesignId?: number;
        BOMDesignId?: number;
        BOMAttributeId?: number;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        SettingId?: number;
        Purity?: number;
        PureWeight?: number;
        StdPurity?: number;
        Remarks?: string;
        PointerWeight?: number;
        CenterStone?: boolean;
        ItemType?: string;
        ProductCode?: string;
        ProductName?: string;
        Attribute?: string;
        CostMethodId?: number;
        ShapeId?: number;
        ShapeCode?: string;
        ShapeName?: string;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        SubCategoryId?: number;
        CategoryCode?: string;
        KaratCode?: string;
        QualityCode?: string;
        QualityName?: string;
        SubCategoryCode?: string;
        StoneColorId?: number;
        StoneColorCode?: string;
        StoneColoreName?: string;
        StoneSizeId?: number;
        SieveId?: number;
        CalcOn?: string;
        GroupSieveId?: number;
        MetalColorId?: number;
        QualityId?: number;
        KaratId?: number;
        ItemTypeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Sys_Date?: string;
    }

    export namespace DesignBOMRow {
        export const idProperty = 'BomId';
        export const nameProperty = 'Remarks';
        export const localTextPrefix = 'OMS.DesignBOM';
        export const deletePermission = 'Designs:Delete';
        export const insertPermission = 'Designs:Add';
        export const readPermission = '*';
        export const updatePermission = 'Designs:Edit';

        export declare const enum Fields {
            BomId = "BomId",
            DesignId = "DesignId",
            BOMDesignId = "BOMDesignId",
            BOMAttributeId = "BOMAttributeId",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            SettingId = "SettingId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            StdPurity = "StdPurity",
            Remarks = "Remarks",
            PointerWeight = "PointerWeight",
            CenterStone = "CenterStone",
            ItemType = "ItemType",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            Attribute = "Attribute",
            CostMethodId = "CostMethodId",
            ShapeId = "ShapeId",
            ShapeCode = "ShapeCode",
            ShapeName = "ShapeName",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            CategoryCode = "CategoryCode",
            KaratCode = "KaratCode",
            QualityCode = "QualityCode",
            QualityName = "QualityName",
            SubCategoryCode = "SubCategoryCode",
            StoneColorId = "StoneColorId",
            StoneColorCode = "StoneColorCode",
            StoneColoreName = "StoneColoreName",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            CalcOn = "CalcOn",
            GroupSieveId = "GroupSieveId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            KaratId = "KaratId",
            ItemTypeId = "ItemTypeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Sys_Date = "Sys_Date"
        }
    }
}
